export default {
  notfound: '頁面不存在',
  case_unavailable: '此判案書並不存在。',
  legis_unavailable: '此法例並不存在。',
  page_unavailable: '此頁面並不存在。',
  bad_query: '系統未能處理你的搜索字串',
  noresult_warn: '沒有文件符合搜索條件',
  nodata_warn: '此資料庫暫時沒有任何文件',
  error: [
    '請使用搜尋欄尋找其他文件，或{0}尋求技術支援。'
  ],
  case_onlyword: '此判案書暫時只提供 Word 版本下載。',
}